/**
 * Handle analytics in wysiwyg container
 *
 * @param container {HTMLElement} data atribut element
 */

const AnalyticsContent = (container) => {
  const { dataLayer } = window;

  container.querySelectorAll("a").forEach((anchor) => {
    const link = anchor.getAttribute("href");
    const content = anchor.textContent.replace(/<[^>]*>/g, "");

    const analytics = container.dataset.analyticsContent
      .replace("LINK", link)
      .replace("TITLE", content)
      .trim();

    const TriggerClick = () => {
      dataLayer.push(JSON.parse(analytics));
    };

    anchor.addEventListener("click", TriggerClick);
  });
};

export default AnalyticsContent;
